// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { Section } from 'util/Types';
import styles from './SelectSectionCard.module.scss';

interface Props {
  section: Section;
  isSelected: boolean;
  onSelectSection: (section: Section) => void;
}
const SelectSectionCard: React.FC<Props> = ({
  section,
  isSelected,
  onSelectSection,
}) => {
  return (
    <div
      key={section.id}
      className={`${styles.section} ${isSelected ? styles.selected : ''}`}
      onClick={() => {
        onSelectSection(section);
      }}
    >
      <p title={section.name}>{section.name}</p>
    </div>
  );
};

export default SelectSectionCard;
